/**
 * @param {string} asset
 * @return {string}
 */
export default asset => `${window.REACT_APP_STATIC_ASSETS_CDN_URL}/${asset}`;
